'use client';

import { useState } from 'react';

import { WAG_API_URL, WalkerProfileV6Endpoints } from '../../../constants';
import { WalkerActivityV6 } from '../../../types/api';
import { tryCatch } from '../../../utils';
import { httpGet } from '../../../wag-react/common/api/api';
import { applyPathParams } from '../../../wag-react/common/api/utils/applyPathParams';

type Props = {
  identifier: string;
}

export const getWalkerActivity = async ({
  identifier,
}: Props) => {
  const walkerActivityUrl = applyPathParams(WalkerProfileV6Endpoints.GetWalkerActivity)({
    identifier,
  });
  const [response, err] = await tryCatch(
    () => httpGet<WalkerActivityV6>(walkerActivityUrl, {
      baseURL: WAG_API_URL,
    }));

  if (err) {
    return null;
  }

  return response.data;
};

export const useGetWalkerActivity = (identifier: string) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState<WalkerActivityV6>();

  const getActivity = async ():
    Promise<WalkerActivityV6> => {
    setIsLoading(true);

    try {
      const walkerActivity = await getWalkerActivity({
        identifier,
      });
      setIsLoading(false);
      setData(walkerActivity);

      return walkerActivity;
    } catch (_error) {
      setError(_error);
      setIsLoading(false);
      return _error;
    }
  };

  return {
    getActivity,
    isLoading,
    error,
    data,
  };
};
